import React, { useEffect, useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
import { adminApi } from '../../lib/api';

export default function AdminMessages() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');

  const refresh = () => {
    adminApi.messages().then(setItems).catch(() => setItems([])).finally(() => setLoading(false));
  };
  useEffect(refresh, []);

  const markReplied = async (id) => {
    await adminApi.updateMessage(id, 'replied');
    setItems((ms) => ms.map((m) => (m.id === id ? { ...m, status: 'replied' } : m)));
  };

  const filtered = filter === 'all' ? items : items.filter((m) => m.status === filter);

  return (
    <div>
      <div className="mb-5 flex items-center justify-between flex-wrap gap-3">
        <div>
          <h2 className="text-xl font-bold text-[#0b1f3a]">Messages</h2>
          <p className="text-slate-500 text-sm mt-1">{items.length} messages total.</p>
        </div>
        <div className="inline-flex bg-slate-100 rounded-full p-1 text-xs">
          {['all', 'new', 'replied'].map((s) => (
            <button
              key={s}
              onClick={() => setFilter(s)}
              className={`px-3 py-1.5 rounded-full font-semibold capitalize ${
                filter === s ? 'bg-white text-[#0d3a8a] shadow-sm' : 'text-slate-500'
              }`}
            >{s}</button>
          ))}
        </div>
      </div>

      {loading ? (
        <p className="p-8 text-center text-slate-500 text-sm">Loading...</p>
      ) : filtered.length === 0 ? (
        <p className="p-8 text-center text-slate-500 text-sm bg-white border border-slate-200 rounded-2xl">No messages match this filter.</p>
      ) : (
        <div className="space-y-3">
          {filtered.map((m) => (
            <div key={m.id} className="bg-white border border-slate-200 rounded-2xl p-5">
              <div className="flex items-start justify-between gap-4 flex-wrap">
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2 flex-wrap">
                    <p className="font-semibold text-[#0b1f3a]">{m.subject}</p>
                    <span className="text-[10px] uppercase font-semibold tracking-wider px-1.5 py-0.5 rounded bg-slate-100 text-slate-600">{m.source}</span>
                    <span className={`text-[10px] uppercase font-semibold tracking-wider px-1.5 py-0.5 rounded ${
                      m.status === 'new' ? 'bg-amber-100 text-amber-700' :
                      m.status === 'replied' ? 'bg-emerald-100 text-emerald-700' :
                      'bg-slate-100 text-slate-600'
                    }`}>{m.status}</span>
                  </div>
                  <p className="text-xs text-slate-500 mt-1">{m.name || m.email || 'anonymous'} · {new Date(m.created_at).toLocaleString()}</p>
                  <p className="text-sm text-slate-700 mt-2 whitespace-pre-line leading-relaxed">{m.message}</p>
                </div>
                {m.status !== 'replied' && (
                  <button onClick={() => markReplied(m.id)} className="btn-outline !py-2 !px-3 text-xs whitespace-nowrap">
                    <CheckCircle2 size={14} /> Mark replied
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
